define('meta/likes',['jquery'], function ($) {

	/*
	 * likes : [ [ type, username, user_id] , ] => new Likes(data.likes) . draw (somewhere)
	 * reactions : [ {id, writer, user_id, message, likes : [ [type, username, user_id], ] } , ] => new Reactions(data.reactions).draw(somewhere)
	 * tags: [ {title, user_id, location : [x1,y1, x2,y2] } , ] => tags.handleTags(data.tags);
	 */

	/**
	 * Likes wrapper
	 * 
	 * $: rule : object to add the like box
	 * function: getItemId: Which item to like  
	 * Cache: cache object
	 * obj: url_defaults: Used to overwriten default url functionality of $.url 
	 */
	var Likes = function (options) {
		this.options = $.extend({
			rule : null,
			getItemId : function () { return 0; },
			cache : null,
			url_defaults : {},
			
			enabled : true
		}, options);
		
		this.remove = function () {
			this.options.rule.find('.likes .message').empty();
		};
		
		this.element = this.like = null;
		
		this.init();
	};
	
	Likes.prototype.init = function () {
		var $this = this;
		this.element = $('<span class="likes"></span>');
		
		this.like = $('<a href="#" class="likeable">').text('like').addClass('like');
		
		this.like.on('click', function () {
			var el = $(this);
			var action = el.is('.unlike') ? 'unlike' : 'like';
			
			$.post($.url(action, {id : $this.options.getItemId() }, $this.options.url_defaults), function (data) {
				
				$this.render(data);
				
				if($this.options.cache != null)
					$this.options.cache.dirty($this.options.getItemId.call($this));
			});
			
			return false;
		});
		
		this.element.append('<span class="message"></span>');
		
		this.element.append(this.like);
		
		this.element.find('.message').on('mouseenter', 'a', function () {
			var el = $(this);
			
			var obj = $('<div class="likebox">');
				var ul = $('<ul>');
				$.each(el.data('names'), function () {
					ul.append($('<li>').text(this));
				});
			
			obj.append(ul);
			
			el = $(this);
			var xy = el.offset();
			
			el.after(obj);
			obj.offset({
				'left' : xy.left,
				'top' : xy.top + el.height
			});
			
			var timer = null;
			
			el.parent().mouseleave(function () {
				timer = setTimeout(function () {
					obj.remove();
				}, 1000);
			});
			el.parent().mouseenter(function () {
				if (timer != null)
					clearTimeout(timer);
			});
			
			return false;
		});
		
		this.options.rule.append(this.element);
	};
	
	/**
	 * Renders the message with names
	 * @param iLike
	 * @param object
	 * @returns void
	 */
	Likes.prototype.renderMessage = function (iLike, object) {
		var me = $.userId();

		var len = object.length;
		
		if(iLike) {
			len = len - 1;
			object = jQuery.grep(object, function (val) {
				return val.user_id != me;
			});
		}
		
		/**
		 * Opties
		 * 
		 * iLike => U
		 * iLike en 1 ander => U en x
		 * iLike en 2 anderen => U, x en y vinden dit leuk
		 * iLike en meerdere anderen => U, x en 2 anderen vinden dit leuk
		 * 
		 * 1 => x 
		 * 2 => x en y
		 * 3 => x, y en z
		 * 4 => x, y en 2 anderen
		 * 5 => x, y en 3 anderen
		 * 
		 */
		var css = 'likings';
		var tekst = "";
		var names = [];
		var more = true;
		
		// Alleen eerste naam met hoofdletter
		if (len>0 && iLike)
			object[0].name = object[0].name.charAt(0).toLowerCase() + object[0].name.slice(1);
		
		if ((len == 2 && iLike) || (len >=2 && !iLike))
			object[1].name = object[1].name.charAt(0).toLowerCase() + object[1].name.slice(1);
		
		switch(true) {
			case (!iLike && len == 0):
				css = 'none';
			break;
			
			case (iLike && len == 0):
				tekst += "U";
				more = false;
			break;
		
			case (iLike && len == 1):
				tekst += "U en " + object[0].name;
			break;
			
			case (iLike && len == 2):
				tekst += "U, " + object[0].name + " en " + object[1].name;
			break;
			
			case (iLike && len > 2):
				
				for(var i = 1; i < object.length; i++) {
					names.push(object[i].name);
				}
				
				tekst += "U, " + object[0].name + " en <a>" + names.length + " " + (names.length == 1 ? 'ander' : 'anderen') + "</a>";
			break;
			
			case (len == 1):
				tekst += object[0].name;
				more = false;
			break;
			
			case (len == 2):
				tekst += object[0].name + " en " + object[1].name;
			break;
			
			case (len == 3):
				//Geen hoofdletter aan begin bij laatste naam
				object[2].name = object[2].name.charAt(0).toLowerCase() + object[2].name.slice(1);
				tekst += object[0].name + ", " + object[1].name + " en " + object[2].name;
			break;
			
			case (len > 3):
				for(var i = 2; i < object.length; i++) {
					names.push(object[i].name);
				}
				
				tekst += object[0].name + ", " + object[1].name + " en <a>" + names.length + " " + (names.length == 1 ? 'ander' : 'anderen') + "</a>";
			break;
		}
		if (css == 'none' && me != 0 && this.options.enabled)
        {
            tekst =  ' Vind dit als eerste leuk';
        }
		else if(css == 'none') {
			tekst = ' ';
		} else {
			if(!more) {
				tekst += " vindt dit leuk";
			} else {
				tekst += " vinden dit leuk";
			}
		}
		tekst += " "; 
		
		var ret = $('<span>').html(tekst).addClass(css);
		ret.find('a').data('names', names);
		
		return ret;
	};

	Likes.prototype.render = function (object) {
		this.remove();

		var me = $.userId();
		var ilike = false;
		
		// parse
		$.each(object, function () {
			if(parseInt(this.user_id) == me) {
				ilike = true;
			}
		});
		
		if(this.options.enabled && me != 0) {
			var action = ilike ? 'unlike' : 'like';
			this.like.text(action).removeClass('like unlike').addClass(action);
		} else {
			this.like.css('display', 'none');
		}
		
		var message = this.element.find('.message');
		
		message.empty().append(this.renderMessage(ilike, object));
	};

	/**
	 * jQuery equivalet of like
	 * 
	 * like object needs 
	 * int: data-id: item id to like
	 * string: data-type: type of like, needed for knowking which controller is needed
	 * JSON: data-likes: likes dat er nu al zijn
	 */
	$.fn.like = function (settings) {
		return this.each(function () {
			var el = $(this);
			var item_id = el.data('id');
			var type = el.data('type');
			var types = configure.types[type] != undefined ? configure.types[type] : {};
			
			var l = new Likes({
				rule : $(this),
				getItemId : function () {
					return item_id;
				},
				cache : null,
				url_defaults : types
			});
			
			var data = el.attr('data-likes');
			if(data != undefined) {
				l.render(jQuery.parseJSON(data));
			} else {
				// data ophalen via cache e.d. via meta, maar niet erg efficient deze methode...
			}
		});
	};
	
	
	return Likes;
});
